<div *ngIf="showClose">
    <cbic-static-text [textEn]="cbicContentMst!.titleEn" [textHi]="cbicContentMst!.titleHi"></cbic-static-text>
    <button type="button" class="btn-close float-end" aria-label="Close" (click)="closeModel()"></button>
</div>
<section class="custom-box1">
    <div class=" col-xs-12 col-md-12 col-lg-12 card tender-auction-section1 ">
        <nav aria-label="breadcrumb" *ngIf="isBreadcrumb">            
            <ol class="breadcrumb" *ngIf="topNavigationService.getNavigation() as topNavigation">
                <span *ngIf="topNavigationService.showMenuLink()"
                    class="breadcrumb-item">
                     <a *ngIf="cbicContentMst?.contentType?.id !==53"  routerLink="/{{topNavigationService.getMenuItem().path}}" class="bredcrumb-trimmed-text" cbicTranslate="menu.{{topNavigationService.getMenuItem().menuName}}"></a>
                    <a *ngIf="cbicContentMst?.contentType?.id ==53 && topNavigationService.getMenuItem().menuName =='GST' "  routerLink="/entities/cbic-content-mst/MTY0MTM%3D" class="bredcrumb-trimmed-text" title="citizen-corner" cbicTranslate="menu.{{topNavigationService.getMenuItem().menuName}}"></a>
                    <a *ngIf="cbicContentMst?.contentType?.id ==53 && topNavigationService.getMenuItem().menuName =='Customs' "  routerLink="/entities/cbic-content-mst/MTY0MTc%3D" class="bredcrumb-trimmed-text" title="citizen-corner" cbicTranslate="menu.{{topNavigationService.getMenuItem().menuName}}"></a>
               </span>
                <span *ngFor="let nav of topNavigation; index as inx"
                    class="breadcrumb-item {{inx == topNavigation.length-1?'active':''}}">
                    <cbic-link *ngIf="inx < topNavigation.length-1" class="bredcrumb-trimmed-text"
                        [linkEn]="'/entities/cbic-content-mst/'+nav.id"
                        [linkTextEn] = "nav.displayTextEn" [linkTextHi] = "nav.displayTextHi"></cbic-link>
                    <span *ngIf="inx == topNavigation.length-1">
                        <cbic-static-text [textEn]="nav.displayTextEn" [textHi]="nav.displayTextHi"></cbic-static-text>
                    </span>
                </span>
            </ol>
        </nav>
        <div class="custom-scroll-bar height-auto" >
            <div *ngIf="cbicContentMst" class="">
                <!-- Instructions/information about content   -->
                <cbic-static-text *ngIf="hasInfo(cbicContentMst)" class="content-info " [textEn]="cbicContentMst.infoEn" [textHi]="cbicContentMst.infoHi"
                    [html]="true"></cbic-static-text>
                <!-- documents liked with content   -->
                <table *ngIf="cbicContentMst!.cbicDocMsts && cbicContentMst.cbicDocMsts.length > 0" class="table table-condensed table-hover table-bordered table-striped table-fixed shadow tender-auction-data">
                    <thead class="table-light">
                        <tr>
                            <th>S.No.</th>
                            <th>Title</th>
                            <th>Link/Download</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let doc of cbicContentMst!.cbicDocMsts; index as inx"
                        (click)="viewFile(doc)" class="pop-link">
                            <td>{{inx+1}}</td>
                            <td> 
                                <cbic-static-text [textEn]="doc.docTitleEn" [textHi]="doc.docTitleHi"></cbic-static-text>
                            </td>
                            <td><span ngClass="{{utils.getDocumentIcon(doc.docType)}}"> </span></td>
                        </tr>
                    </tbody>
                </table>
                <!-- children of content   -->
                <cbic-table *ngIf="cbicContentMst.viewType == 1" id="{{cbicContentMst.id}}"
                    [data]="cbicContentMst" [linkUrl]="isBreadcrumb"></cbic-table>
                <cbic-accordian *ngIf="cbicContentMst.viewType == 2" id="{{cbicContentMst.id}}"
                    [data]="cbicContentMst"></cbic-accordian>
                <cbic-tiles *ngIf="cbicContentMst.viewType == 3" id="{{cbicContentMst.id}}"
                    [data]="cbicContentMst"></cbic-tiles>
            </div>
        </div>
    </div>
</section>